/*
 * @Description: 
 * @Author: 姜暖阳
 * @Date: 2021-10-21 15:15:57
 * @LastEditTime: 2023-10-08 11:05:46
 * @LastEditors: 赵大壮
 * @Reference: 
 */
import config from '../nyConfig'
const ApiInformation = {
    "添加资讯分类": new config({url: '/information/addType', showSuccessMessage: true, useToken: true }),
    "编辑资讯分类": new config({url: '/information/editType', showSuccessMessage: true, useToken: true }),
    "删除资讯分类": new config({url: '/information/delType', showSuccessMessage: true, useToken: true }),
    "资讯分类列表": new config({url: '/information/pageType', showSuccessMessage: false, useToken: true }),
    "资讯分类所有": new config({url: '/information/listType', showSuccessMessage: false, useToken: true }),

    "添加资讯": new config({url: '/information/addInformation', showSuccessMessage: true, useToken: true }),
    "编辑资讯": new config({url: '/information/editInformation', showSuccessMessage: true, useToken: true }),
    "删除资讯": new config({url: '/information/delInformation', showSuccessMessage: true, useToken: true }),
    "资讯分页列表": new config({url: '/information/pageInformation', showSuccessMessage: false, useToken: true }),
    "资讯列表": new config({url: '/information/listInformation', showSuccessMessage: false, useToken: true }),
    "资讯详情": new config({url: '/information/getInformation', showSuccessMessage: false, useToken: true }),
}

export default ApiInformation
